import {Card, CardContent} from '@mui/material';
import CardActions from '@mui/material/CardActions';
import { Skeleton } from '@mui/material';
import {lazy, Suspense} from 'react';

const LazyComparableItemSummaryAug2020 = lazy(() => import('./ComparableItemSummaryAug2020'));

const FallbackComponent = (
  <Card classes={{ root: 'ComparableItemSummaryAug2020'}}>
    <div className="head">
      <div className="card-header-left" style={{display: 'flex'}}>
        <Skeleton className="avatar"
                  variant="circular"
                  width={30}
                  height={40}/>
        <Skeleton className="property-address" variant="text" width={420}/>
      </div>

      <div className="card-header-right">
        <Skeleton variant="text" className="sale-price" />
      </div>
    </div>
    <div className="body">
      <Skeleton variant="rectangular" width={228} height={152}/>
      <CardContent classes={{root: 'details'}} style={{width: '68%'}}>
        <Skeleton variant={'text'} width="80%" height={40}/>
        <Skeleton variant={'text'} width="100%" height={35}/>
        <Skeleton variant={'text'} width="100%" height={35}/>
        <Skeleton variant={'text'} width="100%" height={35}/>
        <Skeleton variant={'text'} width="100%" height={35}/>
      </CardContent>
    </div>
    <CardActions disableSpacing classes={{root: 'actions'}}>
      <Skeleton variant="rectangular" width="100%" height={70}/>
    </CardActions>
  </Card>
);

const ComparableItemSummaryAug2020 = props => (
  <Suspense fallback={FallbackComponent}>
    <LazyComparableItemSummaryAug2020 {...props} />
  </Suspense>
);

export default ComparableItemSummaryAug2020;
